import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	ITest,
	LabelPosition,
} from "@websential/cosmic-v20";
import { FC, useEffect } from "react";


interface ISimplePayInvoiceInfoFieldsPanel extends ITest {
	accountSettingsDDL:any;
}

export const SimplePayInvoiceInfoFieldsPanel: FC<ISimplePayInvoiceInfoFieldsPanel> = ({
	accountSettingsDDL
}) => {
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Terms or Payment Account"
				selectName="termsOrPaymentAccount"
				testId="terms-or-payment-account"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
				<EnhancedDropDownRHFWithLabel
				label="Invoice"
				selectName="invoice"
				testId="earnings-hours"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
		</>
	);
};
